import React from "react";
import Banner from "./Banner";
import GridView from "../components/GridView";

const Home = () => {
  return (
    <>
      <Banner />
      <GridView />
    </>
  );
};

export default Home;
